import { Modal, TextContainer, TextField } from "@shopify/polaris"
import { isEmpty } from "lodash-es"
import { Observer } from "mobx-react"
import { ProTextField } from "polaris-enhance"
import React, { useCallback, useState } from "react"
import isEmail from "validator/lib/isEmail"

import APIDashboard from "@/api/dashboard"
import stores from "@/stores"
import { hideServerErr } from "@/utils/request"
import toast from "@/utils/toast"

interface FeedbackModalProps {
  show: boolean
  onClose(): void
}

export default function BadFeedBackModal({
  onClose,
  show,
}: FeedbackModalProps) {
  const [email, setEmail] = useState<string>("")
  const emailHandleChange = useCallback((newValue) => setEmail(newValue), [])

  const [content, setContent] = useState<string>("")
  const msgHandleChange = useCallback((newValue) => setContent(newValue), [])

  const [emailFlag, setEmailFlag] = useState<boolean>(false)
  const emailFlagHandleChange = useCallback(
    (active) => setEmailFlag(active),
    [emailFlag],
  )

  // modal 主按钮是否在加载中
  const [btnLoading, setBtnLoading] = useState<boolean>(false)
  const toggleBtnLoading = useCallback(setBtnLoading, [])

  const { UserInfoStore } = stores

  const handleFeedbackRequest = async () => {
    toggleBtnLoading(true)
    if (emailFlag && !isEmail(email)) {
      toggleBtnLoading(false)
      return
    }
    try {
      toggleBtnLoading(true)
      const res = await APIDashboard.sendFeedback(
        !email ? UserInfoStore.data.email : email,
        content,
      )

      if (res.data.code === 1000) {
        toast(t("SentSuccessfully"))
        UserInfoStore.setSingleData("is_close_praise_guide", true)
      } else {
        toast(hideServerErr(res.data.message), 4e3, true)
      }
      msgHandleChange("")
      onClose && onClose()
    } catch (err) {
      console.log(err)
    } finally {
      toggleBtnLoading(false)
    }
  }

  const handleClose = () => {
    if (UserInfoStore.data.email && !isEmail(email)) {
      setEmail(UserInfoStore.data.email)
    }
    onClose && onClose()
  }

  return (
    <>
      <Observer>
        {() => (
          <Modal
            open={show}
            onClose={handleClose}
            title={t("SendYourFeedback")}
            primaryAction={{
              content: t("Send"),
              disabled: isEmpty(content),
              loading: btnLoading,
              onAction: () => {
                handleFeedbackRequest()
              },
            }}
            secondaryActions={[
              {
                content: t("Cancel"),
                onAction: handleClose,
              },
            ]}
          >
            <Modal.Section>
              <TextContainer>
                <TextField
                  label={t("PleaseTellUsMoreWeWillTryTheBest")}
                  value={content}
                  maxLength={500}
                  placeholder={t("EditYourMessageHere")}
                  onChange={msgHandleChange}
                  autoFocus
                  maxHeight={"10.6rem"}
                  multiline={4}
                  autoComplete="off"
                />

                {/* 当不存在值时，使用外面传来的邮箱 */}
                {!emailFlag && (
                  <ProTextField
                    type="email"
                    label={t("YourContactEmail")}
                    value={UserInfoStore.data.email}
                    error={
                      !isEmail(UserInfoStore.data.email)
                        ? t("PleaseEnterAValidEmail")
                        : ""
                    }
                    autoComplete="off"
                    onChange={(v) => {
                      emailHandleChange(v)
                      emailFlagHandleChange(true)
                    }}
                  />
                )}

                {/* 只要一存在，马上切换为真是输入框 */}
                {emailFlag && (
                  <ProTextField
                    type="email"
                    label={t("EditYourMessageHere")}
                    value={email}
                    error={!isEmail(email) ? t("PleaseEnterAValidEmail") : ""}
                    placeholder={t("EGEcomsend100GmailCom")}
                    autoComplete="off"
                    autoFocus
                    onChange={emailHandleChange}
                  />
                )}
              </TextContainer>
            </Modal.Section>
          </Modal>
        )}
      </Observer>
    </>
  )
}
